module.exports = __webpack_public_path__ + "static/media/st.b586afcd.svg";